import {Navigate, useNavigate} from 'react-router-dom';
import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';
import chekinLogo from 'assets/icons/accept-icon.svg?no-inline';
import {useLazyImport} from '@chekin/core';
import {useLayoutMode} from 'hooks/useLayoutMode';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {LanguageButton} from 'components/LanguageButton';

function WelcomeScreen() {
  const {t} = useTranslation('kiosko');
  const layoutMode = useLayoutMode();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {getLazyValue: getTapScreenAnimation} = useLazyImport(
    () => import('assets/lotties/tap-screen.json'),
  );
  const tapScreenAnimation = getTapScreenAnimation();
  const handleTapScreen = () => {
    navigate(getFullPath(PATHS.searchReservation.main));
  };

  if (layoutMode !== 'kiosko') {
    return <Navigate to={getFullPath(PATHS.searchReservation.main)} replace />;
  }

  return (
    <>
      <div
        className="flex flex-col items-center justify-center h-screen w-full pb-[64px]"
        onClick={handleTapScreen}
      >
        <div className="fixed top-6 right-6 z-50" onClick={e => e.stopPropagation()}>
          <LanguageButton className="bg-white rounded-2xl px-6 py-4 shadow-none kiosko:text-kiosko-m kiosko:font-light" />
        </div>

        <img
          src={chekinLogo}
          alt="Check icon"
          className="w-[450px] h-[302px] object-contain mb-[56px]"
          width="450px"
          height="302px"
        />
        <div className="flex flex-col items-center gap-[48px]">
          <h1 className="text-[76px] font-medium leading-[40px] text-gray-900">
            {t('welcome')}
          </h1>
          <p className="text-kiosko-s font-normal leading-[56px] text-gray-700">
            {t('tap_here_to_start_your_check_in')}
          </p>
        </div>
        <div className="flex flex-col items-center gap-[40px]">
          <div>{tapScreenAnimation && <Lottie animationData={tapScreenAnimation} />}</div>
        </div>
      </div>
    </>
  );
}

export {WelcomeScreen};
